import React, { FC } from 'react';
import styled from 'styled-components';
import { styles } from '@sdir/sds';
import { PageIcons } from '../../Atoms';

type NavCardProps = {
  heading: string;
  description?: string;
  PrimaryIcon: any;
  SecondaryIcon?: any;
  onClick?: () => void;
};

export const NavCard: FC<NavCardProps> = ({
  heading,
  description,
  PrimaryIcon,
  SecondaryIcon,
  onClick,
}) => {
  return (
    <Outer
      onClick={onClick}
      role={onClick ? 'link' : 'generic'}
      tabIndex={onClick ? 0 : -1}
      onKeyUp={(e) => e.key === 'Enter' && onClick?.()}
    >
      <PageIcons PrimaryIcon={PrimaryIcon} SecondaryIcon={SecondaryIcon} />
      <ContentWrapper>
        <h2>{heading}</h2>
        {description && <span>{description}</span>}
      </ContentWrapper>
    </Outer>
  );
};

const Outer = styled.article`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  min-width: 480px;
  width: 480px;
  height: 200px;
  padding: 30px;
  box-shadow: 0px 6px 12px #33333333;
  transition: background-color 0.2s ease-in, box-shadow 0.2s ease-in;
  border-radius: ${styles.card.borderRadius};
  background-color: ${styles.colors.background.secondary};

  &:hover,
  &:active,
  &:focus {
    background-color: #66d1c2;
    cursor: pointer;
    box-shadow: ${styles.card.boxShadow};

    & .primary-icon {
      top: 5px;
    }
    & .secondary-icon {
      bottom: 5px;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.screen.medium}) {
    width: 100%;
    min-width: 0;
    height: auto;
    padding: 15px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    text-decoration: underline;
  }
`;
